import { FormTime } from '@glow/ui-components'
import { FieldValidator, useField } from 'formik'
import React, { ReactNode } from 'react'
import { useFormikError } from '../formik-error'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string
  label: string
  validate?: FieldValidator
  descriptionText?: string
  hideLabel?: boolean
  icon?: ReactNode
}
export const FormikTime = (props: Props) => {
  const { name, validate, ...rest } = props
  const [field] = useField({ name, validate })
  const error = useFormikError(name, validate)

  return (
    <FormTime
      onValueChange={(value: string) => field.onChange({ target: { value, name } })}
      {...rest}
      {...field}
      aria-invalid={Boolean(error)}
      errorMessage={error?.message}
    />
  )
}
